import React from "react";
import { graphql } from "gatsby";
import StructuredText from "../custom-structured-text-renderer";
import parse from "html-react-parser";
import { Link, Asset } from "../../../../plugins/gatsby-plugin-atollon";
import { RightArrow } from "../../icons";
import AnimationButton from "./animation-button";

const StickyCard = ({title, items}) => {
  return (
    <section className="sticky-card">
      <div className="sticky-card__inner">
        {title && <h2>{parse(title)}</h2>}
        <div className="sticky-card__items">
          {
            items?.length > 0 && items.map((el, i) => (
              <div key={i} className={`sticky-card__item sticky-card__item-${i}`}>
                <div className="sticky-card__item-content">
                  {el.title && <h3>{el.title}</h3>}
                  {el.richContent && <StructuredText data={el.richContent}/>}
                  {el.button.length > 0 &&
                    <AnimationButton
                      className="btn btn--animation"
                      to={el.button[0].link[0].externalLink ? el.button[0].link[0].externalLink : el.button[0].link[0].internalLink?.permalink}>
                      {el.button[0].title}
                      <RightArrow color="#ffffff"/>
                    </AnimationButton>
                  }
                </div>

                <div className="sticky-card__item-image">
                  {el.title && <h3>{el.title}</h3>}
                  {el.image && <Asset asset={el.image}/>}
                </div>
              </div>
            ))
          }
        </div>
      </div>
    </section>
  )
}

export default StickyCard

export const query = graphql`
fragment StickyCardProps on DatoCmsStickyCard {
  ... on DatoCmsStickyCard {
    id
    title
    items {
      title
      richContent {
        value
      }
      image {
        ...InternalAssetProps
      }
      button {
        ...LinkWithTitleProps
      }
    }
  }
}
`

